import {Component, OnInit, ViewChild} from '@angular/core';
import {
  ActivatedRoute,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from '@angular/router';
import {filter, switchMap, tap} from 'rxjs/operators';
import {ModalComponent} from 'src/app/components/modal/modal.component';
import {AuthServiceProvider} from 'src/app/services/col2/auth.service';
import {FunctionalAccessService} from 'src/app/services/functional-access.service';
import {V3School} from "../../../model/v3/schools";
import {SchoolV3RestService} from "../../../services/rest/v3/school-rest.service";

@Component({
    selector: 'app-admin-school-details-page',
    templateUrl: './admin-school-details-page.component.html',
    styleUrls: ['./admin-school-details-page.component.scss'],
    standalone: false
})
export class AdminSchoolDetailsPageComponent implements OnInit {
  schoolId: number;
  school: V3School;
  currentFragment: string;
  private currentFragments: string[];

  @ViewChild('renewalModal', { static: true }) renewalModal: ModalComponent;
  @ViewChild('deleteModal', { static: true }) deleteModal: ModalComponent;

  constructor(
    private route: ActivatedRoute,
    router: Router,
    private authProvider: AuthServiceProvider,
    private functionalAccessService: FunctionalAccessService,
    private schoolV3Rest: SchoolV3RestService,
  ) {
    router.events
      .pipe(
        filter((e: Event): e is NavigationStart | NavigationEnd | NavigationCancel | NavigationError => e instanceof NavigationStart ||
                            e instanceof NavigationEnd ||
                            e instanceof NavigationCancel ||
                            e instanceof NavigationError))
      .subscribe((e: RouterEvent) => {
        e['urlAfterRedirects']
          ? (this.currentFragments = e['urlAfterRedirects'].split('/'))
          : '';
        this.currentFragment =
          this.currentFragments[this.currentFragments.length - 1];
      });
  }

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        tap((params) => (this.schoolId = +params.get('schoolId'))),
        switchMap((_) => this.schoolV3Rest.getSchool(this.schoolId)),
        tap((school) => (this.school = school))
      )
      .subscribe();
  }

  logInAsManager() {
    this.authProvider
      .get()
      .pipe(
        tap((auth) => auth.logInAsManager(this.schoolId, null)),
        //reinitialize functionalAccess when admin has manager school id
        tap(_ => this.functionalAccessService.initialize())
      ).subscribe()
  }
}
